const SoloTexto = (data) =>{
  let texto = data ? data.replace(/<[^>]*>?/g, '') : "";
  return texto;
}

export default SoloTexto;